import { AxiosResponse } from "axios";
import { VerificationAgency } from "../../Model/Dto/VerificationAgency/VerificationAgency"
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.VerificationAgency" ;
export const VerificationAgencyService = {
    GetVaDetails: (): Promise<AxiosResponse<VerificationAgency.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.get(ApiUrls.GetVaDetails),

    GetVaDetailsLinkedToSubmittedScorecard: (scorecardId: string): Promise<AxiosResponse<VerificationAgency.VerificationAgencyClientResponse>> =>
        axiosCoreInstance.get(`${ApiUrls.GetVaDetailsLinkedToSubmittedScorecard}/${scorecardId}`),

    UpdateVerificationAgency: (verificationAgencyId: string | null): Promise<AxiosResponse<string>> => {
        const query = verificationAgencyId ? `?verificationAgencyId=${verificationAgencyId}` : ``;
        return axiosCoreInstance.put(`${ApiUrls.VerificationAgencyBase}${query}`);
    },

    GetVerificationAgencies: () :Promise<AxiosResponse<VerificationAgency.VerificationAgencyLookupDto[]>> =>
        axiosCoreInstance.get(ApiUrls.GetVerificationAgencies),

    GetVerificationAgenciesWithConfig: () : Promise<AxiosResponse<VerificationAgency.ExportConfigVerificationAgencyWithConfigDto[]>> =>
        axiosCoreInstance.get(ApiUrls.GetVerificationAgenciesWithConfig),

};
